// src/pages/projects/work-at-hoody.jsx
import "./projects.css";
import SectionMediaRight from "../../components/section-templates/SectionMediaRight";
import { MotionContainer, MotionItem } from "../../animations/MotionWrappers";
import VideoCard from "../../components/VideoCard";

export default function WorkAtThinkMarkets() {
  // 4 GIFs/images for the bento grid

  return (
    <>
      <MotionContainer className="container thinkmarkets-page">
        {/* Spacer */}
        <MotionItem className="thinkmarkets-spacer" />

        {/* Title */}
        <MotionItem delayChildren={0.02} className="container main-title">
          My contribution at Hoody
        </MotionItem>

        {/* Overview & Approach */}
        <div className="info-columns">
          <MotionItem delayChildren={0.02} className="info-block">
            <h2>Overview</h2>
            <p>
              Hoody is a next-level privacy platform that goes beyond
              traditional VPNs by offering per-app VPN routing. My role involved
              creating engaging, informative animations that showcased Hoody's
              unique features and benefits, enhancing user understanding and
              engagement.
            </p>
          </MotionItem>
          <MotionItem className="info-block">
            <h2>Approach</h2>
            <p>
              I created a scalable animation library and design system using{" "}
              <strong>NEEDS TO BE UPDATED</strong>, <strong>2D</strong>, and{" "}
              <strong>3D</strong>.
            </p>
          </MotionItem>
        </div>

        {/* Video */}
        <MotionItem className="VID-fullmedia">
          <VideoCard
            src="https://www.youtube.com/watch?v=D2ILZCLLdlY"
            title="Hoody Beta Launch [Draft version 6]"
          />
        </MotionItem>

        <SectionMediaRight
          imageSrc="/assets/Images/Portfolio/work-at-thinkmarkets/animation-system.webp"
          title="40% Faster Delivery with Animation System"
          text="I built a reusable animation library and a set of how-to templates that standardize our video creation process. This toolkit cuts 3-4 hours of work per project and drives a measurable boost in overall production efficiency."
        />
      </MotionContainer>
    </>
  );
}
